import React from "react";
import { Card, Form, Row, Col } from "react-bootstrap";

const FleetSection = ({ data, onUpdate }) => {
  const handleChange = (field, value) => {
    onUpdate({ ...data, [field]: value });
  };

  const handleConfigChange = (field, value) => {
    onUpdate({
      ...data,
      config: {
        ...(data.config || {}),
        [field]: value,
      },
    });
  };

  return (
    <Card className="mb-4 shadow">
      <Card.Header className="bg-neutral-gray text-dark d-flex justify-content-between align-items-center">
        <h5 className="mb-0 text-dark">Fleet Section</h5>
        <Form.Check
          type="checkbox"
          label="Visible"
          checked={data.isVisible}
          onChange={(e) => handleChange("isVisible", e.target.checked)}
          className="mb-0"
        />
      </Card.Header>
      {data.isVisible && (
        <Card.Body>
          <Row>
            <Col md={12}>
              <Form.Group className="mb-3">
                <Form.Label>Heading</Form.Label>
                <Form.Control
                  type="text"
                  value={data.heading || ""}
                  onChange={(e) => handleChange("heading", e.target.value)}
                  placeholder="Enter fleet section heading"
                />
              </Form.Group>
            </Col>
            <Col md={12}>
              <Form.Group className="mb-3">
                <Form.Label>Paragraph</Form.Label>
                <Form.Control
                  as="textarea"
                  rows={4}
                  value={data.paragraph || ""}
                  onChange={(e) => handleChange("paragraph", e.target.value)}
                  placeholder="Enter fleet section paragraph"
                />
              </Form.Group>
            </Col>
            <Col md={12}>
              <h6 className="fw-bold mb-3">Config</h6>
            </Col>
            <Col md={4}>
              <Form.Group className="mb-3">
                <Form.Check
                  type="checkbox"
                  label="Show Price"
                  checked={!!data.config?.showPrice}
                  onChange={(e) =>
                    handleConfigChange("showPrice", e.target.checked)
                  }
                />
              </Form.Group>
            </Col>
            <Col md={4}>
              <Form.Group className="mb-3">
                <Form.Check
                  type="checkbox"
                  label="Show Book Now Button"
                  checked={!!data.config?.showBookNowButton}
                  onChange={(e) =>
                    handleConfigChange("showBookNowButton", e.target.checked)
                  }
                />
              </Form.Group>
            </Col>
            <Col md={4}>
              <Form.Group className="mb-3">
                <Form.Label>Book Now Button Text</Form.Label>
                <Form.Control
                  type="text"
                  value={data.config?.bookNowButtonText || ""}
                  onChange={(e) =>
                    handleConfigChange("bookNowButtonText", e.target.value)
                  }
                  placeholder="Book Now"
                  disabled={!data.config?.showBookNowButton}
                />
              </Form.Group>
            </Col>
          </Row>
        </Card.Body>
      )}
    </Card>
  );
};

export default FleetSection;
